import React from 'react';

import { Card, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { InputSearch, StatusFilterSelect } from 'common/components';

const ItemsFilter = ({
    filterData,
    handleOnChangeSearch,
    handleOnSelectStatus,
}) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="end" justifyContent="flex-end">
                    <Grid size={{ lg: 15, md: 9, xs: 18 }}>
                        <InputSearch
                            placeholder={t('Search panel')}
                            onChange={handleOnChangeSearch}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid size={{ lg: 3, md: 9, xs: 18 }}>
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={handleOnSelectStatus}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Card.Body>
        </Card>
    );
};

ItemsFilter.propTypes = {
    filterData: PropTypes.object,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
};

export default ItemsFilter;
